<main>

  <caixa-webcomponent-navigation-bar />

  <!-- Header -->
  <header class="credit-cards-header">
    <caixa-webcomponent-main-title
      text="Cartões de Crédito Open Finance"
    />
  </header>
  <!-- ! Header -->

  <!-- Credit Cards Management -->
  <section class="cds-card management-section">
    <!-- Credit Cards Management Header -->
    <header class="management-header">
      <div class="management-title-content">
        <h3 class="section-title">
          Gestão de Cartões de Crédito
        </h3>

        <p class="section-subtitle">
          Última atualização {{ lastUpdate() | date:'dd/MM/yyyy HH:mm:ss' }}
        </p>
      </div>

      <div class="search-input-wrapper">
        <cds-search-input
          [searchValue]="searchTerm()"
          [placeholder]="'Digite o banco, bandeira ou produto contratado'"
          (inputValue)="onSearchChange($event)"
          (clearValue)="onSearchChange('')"
        ></cds-search-input>
      </div>
    </header>
    <!-- !Credit Cards Management Header -->

    <!-- Credit Cards List -->
    @if (hasError()) {
      <section class="credit-cards-error">
        <cds-no-content
          title="Ops!"
          subTitle="Houve uma falha na busca dos cartões de crédito"
        ></cds-no-content>
      </section>
    } @else {
      <section class="credit-cards-list">
        <caixa-webcomponent-data-table
          [data]="tableRows()"
          [config]="tableConfig"
          [actions]="tableActions"
          [loading]="loading()"
          (customCellActionClick)="onCustomCellAction($event)"
          (rowClick)="onNavigateToDetails($event)"
        ></caixa-webcomponent-data-table>
      </section>

      @if (pagination().totalItems > 0 && pagination().totalPages > 0) {
        <section class="pagination-wrapper">
          <cds-pagination
            [totalPages]="pagination().totalPages"
            [totalItems]="pagination().totalItems"
            [page]="currentPage"
            (currentPage)="onCurrentPageChange($event)"
            (offsetChange)="onOffsetChange($event)"
          ></cds-pagination>
        </section>
      }
    }
    <!-- ! Credit Cards List -->

  </section>
  <!-- ! Credit Cards Management -->

</main>
